var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"has-text-weight-bold mt-4 text-base text-gray-500"},[_vm._v(" "+_vm._s(_vm.value.label)+" : ")]),_c('p',[_vm._v(" "+_vm._s(_vm.categoryLabel)+" "),(_vm.subCategoryLabel)?[_c('i',{staticClass:"fal fa-chevron-right text-xs text-gray-400 mx-1"}),_vm._v(" "+_vm._s(_vm.subCategoryLabel)+" ")]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }